import React from "react";

class Footer extends React.Component {
  render() {
    return (

      <footer className="footer mt-auto py-2 fixed-bottom text-center">
          <div className="container">
            <small className="d-block text-muted">技术支持：Brain Lable神经影像分析平台</small>
          </div>
      </footer>
    );
  }
}

export default Footer


// WEBPACK FOOTER //
// ./src/apps/site/common/footer.js